import { render, staticRenderFns } from "./ComboSheet.vue?vue&type=template&id=0c323841&scoped=true"
import script from "./ComboSheet.vue?vue&type=script&lang=js"
export * from "./ComboSheet.vue?vue&type=script&lang=js"
import style0 from "./ComboSheet.vue?vue&type=style&index=0&id=0c323841&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c323841",
  null
  
)

export default component.exports